import React from 'react'
import { useTranslation } from './useTranslation'
import { Language } from './types'

// A single-click toggle between Norwegian and English. Shows the code of the
// language it will switch TO, so the action is self-describing.
export const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage, t } = useTranslation()
  const target: Language = language === 'nb' ? 'en' : 'nb'
  const targetName = target === 'nb' ? t('lang.norwegian') : t('lang.english')

  return (
    <button
      type="button"
      className="btn btn-sm btn-outline-light ms-lg-2"
      onClick={(): void => setLanguage(target)}
      title={`${t('lang.label')}: ${targetName}`}
      aria-label={`${t('lang.label')}: ${targetName}`}
    >
      {target.toUpperCase()}
    </button>
  )
}
